<!-- 搜索销售单急件商品 -->
<template>
    <div class="searchAp-ctn" v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-row">
                    <div class="flex" v-if="StorageId">
                        <div class="search-name">仓库</div>
                        <el-input v-model="warehouseName" :title="warehouseName" class="search-item" size="small" disabled style="width: 110px"></el-input>
                    </div>
                    <el-button size="small" class="search-btn btn-primary" @click="showSearchItem()" tabindex="-1">搜索(F2)</el-button>
                    <el-button v-if="!OnlyOneOption" class="search-btn btn-primary" size="small" @click="chooseAPs()">确定(选中{{ selection.length }}项)</el-button>
                    <el-button v-if="!OnlyOneOption && isSearch" class="search-btn btn-primary" size="small" @click="chooseAllAPs()"
                        >确定(结果{{ tableDataLength }})</el-button
                    >
                    <el-button v-if="isCanTBSet" size="small" icon="el-icon-setting" type="primary" class="search-btn" @click="showTableSetDialog()">表格设置</el-button>
                    <el-button size="small" type="success" class="search-btn" @click="showHistories()">采(F3)</el-button>
                    <el-button size="small" type="success" class="search-btn" @click="showReHistories()">退(F4)</el-button>
                    <el-button size="small" type="danger" class="search-btn" @click="showSaleStat()">销(F5)</el-button>
                    <el-button size="small" type="danger" class="search-btn" @click="showSaleReStat()">退(F6)</el-button>
                    <!-- <el-button size="small" type="primary" class="search-btn" icon="el-icon-s-data" @click="analysis()">(F7)</el-button> -->
                </div>
            </div>
        </div>
        <div class="dialog-search-table-ctn search-table-i">
            <el-table
                ref="dialogTable"
                :data="tableData"
                :header-cell-style="{ background: '#F2F6FC' }"
                border=""
                height="620px"
                style="width: 100%; margin-bottom: 5px"
                @selection-change="onColumnSelect"
                @sort-change="sortChange"
                @row-click="rowClick"
                @cell-dblclick="dblChooseAps"
                @header-dragend="headerDragend"
                v-el-table-infinite-scroll="tableLoad"
                :row-key="getRowKeys"
                highlight-current-row
            >
                <el-table-column type="selection" width="40" reserve-selection v-if="!OnlyOneOption" fixed="left"></el-table-column>
                <el-table-column
                    v-if="columnShowSets.APCode.IsShow"
                    width="200px"
                    :label="columnShowSets.APCode.ColumnName"
                    prop="APCode"
                    show-overflow-tooltip
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    v-if="columnShowSets.GoodName.IsShow"
                    :width="columnShowSets.GoodName.Width > 0 ? columnShowSets.GoodName.Width + 'px' : '150px'"
                    :label="columnShowSets.GoodName.ColumnName"
                    prop="GoodName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.AutoSerise.IsShow"
                    :width="columnShowSets.AutoSerise.Width > 0 ? columnShowSets.AutoSerise.Width + 'px' : '200px'"
                    :label="columnShowSets.AutoSerise.ColumnName"
                    prop="AutoSerise"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Cate.IsShow"
                    :width="columnShowSets.Cate.Width > 0 ? columnShowSets.Cate.Width + 'px' : '100px'"
                    :label="columnShowSets.Cate.ColumnName"
                    prop="Cate"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Brand.IsShow"
                    :width="columnShowSets.Brand.Width > 0 ? columnShowSets.Brand.Width + 'px' : '120px'"
                    :label="columnShowSets.Brand.ColumnName"
                    prop="Brand"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Origin.IsShow"
                    :width="columnShowSets.Origin.Width > 0 ? columnShowSets.Origin.Width + 'px' : '130px'"
                    :label="columnShowSets.Origin.ColumnName"
                    prop="Origin"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Unit.IsShow"
                    :width="columnShowSets.Unit.Width > 0 ? columnShowSets.Unit.Width + 'px' : '80px'"
                    :label="columnShowSets.Unit.ColumnName"
                    prop="Unit"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.SalesCount.IsShow"
                    :width="columnShowSets.SalesCount.Width > 0 ? columnShowSets.SalesCount.Width + 'px' : '80px'"
                    :label="columnShowSets.SalesCount.ColumnName"
                    prop="SalesCount"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Price.IsShow"
                    :width="columnShowSets.Price.Width > 0 ? columnShowSets.Price.Width + 'px' : '80px'"
                    :label="columnShowSets.Price.ColumnName"
                    prop="Price"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.TotalPrice.IsShow"
                    :width="columnShowSets.TotalPrice.Width > 0 ? columnShowSets.TotalPrice.Width + 'px' : '100px'"
                    :label="columnShowSets.TotalPrice.ColumnName"
                    prop="TotalPrice"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.SaleOrderCode.IsShow"
                    :width="columnShowSets.SaleOrderCode.Width > 0 ? columnShowSets.SaleOrderCode.Width + 'px' : '150px'"
                    :label="columnShowSets.SaleOrderCode.ColumnName"
                    prop="SaleOrderCode"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.CusName.IsShow"
                    :width="columnShowSets.CusName.Width > 0 ? columnShowSets.CusName.Width + 'px' : '150px'"
                    :label="columnShowSets.CusName.ColumnName"
                    prop="CusName"
                    show-overflow-tooltip
                ></el-table-column>
                <!-- <el-table-column min-width="200px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="150px" prop="GoodName" label="汽配名称" show-overflow-tooltip></el-table-column>
                <el-table-column width="200px" prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100px" prop="Cate" label="汽配分类" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="120" prop="Brand" label="品牌" show-overflow-tooltip></el-table-column>
                <el-table-column width="130px" prop="Origin" label="产地" show-overflow-tooltip></el-table-column>
                <el-table-column width="80px" prop="Unit" label="单位" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="80" prop="SalesCount" label="急件数" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="80" prop="Price" label="销售单价" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100" prop="TotalPrice" label="销售总额" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="150px" prop="SaleOrderCode" label="销售单号" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="150px" prop="CusName" label="客户名称" show-overflow-tooltip></el-table-column> -->
            </el-table>
        </div>
        <!--    采购历史    -->
        <el-dialog
            :close-on-click-modal="false"
            title="采购历史"
            :visible.sync="historyVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div v-if="historyVisible">
                <APPurchaseHistory
                    ref="APPurchaseHistory"
                    :EntpTempGoodsId="hisGoodsId"
                    :Source="Number(Source)"
                    :EntpCusId="Source == 1 ? EntpCusId : ''"
                    :EntpCusName="Source == 1 ? EntpCusName : ''"
                    :NoInit="noInit"
                    @closeDialog="
                        () => {
                            historyVisible = false;
                        }
                    "
                ></APPurchaseHistory>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog
            :title="SaleDialogTitle"
            :close-on-click-modal="false"
            :visible.sync="eyeHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div v-if="eyeHistoryVisible">
                <APHistory
                    ref="APHistory"
                    :showCusColumn="Source == 0"
                    :EntpCusId="Source == 0 ? EntpCusId : ''"
                    :EntpCusName="Source == 0 ? EntpCusName : ''"
                    :EntpTempGoodsId="hisGoodsId"
                    :NoInit="noInit"
                    @closeDialog="eyeHistoryVisible = false"
                ></APHistory>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="采购退货历史"
            :visible.sync="historyReVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div v-if="historyReVisible">
                <APPurReturnHistory
                    ref="APPurReturnHistory"
                    :EntpTempGoodsId="hisGoodsId"
                    :Source="Number(Source)"
                    :EntpCusId="Source == 1 ? EntpCusId : ''"
                    :EntpCusName="Source == 1 ? EntpCusName : ''"
                    :NoInit="noInit"
                    @closeDialog="
                        () => {
                            historyReVisible = false;
                        }
                    "
                ></APPurReturnHistory>
            </div>
        </el-dialog>
        <!-- 销售退货历史 -->
        <el-dialog
            :title="SaleReDialogTitle"
            :close-on-click-modal="false"
            :visible.sync="eyeReHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div v-if="eyeReHistoryVisible">
                <APSaleReturnHistory
                    ref="APSaleReturnHistory"
                    :showCusColumn="Source == 0"
                    :EntpCusId="Source == 0 ? EntpCusId : ''"
                    :EntpCusName="Source == 0 ? EntpCusName : ''"
                    :EntpTempGoodsId="hisGoodsId"
                    :NoInit="noInit"
                    @closeDialog="eyeReHistoryVisible = false"
                ></APSaleReturnHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog
            :close-on-click-modal="false"
            title="商品销售采购数据图表"
            :visible.sync="goodsAnalysisVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis ref="goodsAnalysis" :GoodsId="hisGoodsId" :NoInit="noInit" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
        <!-- 数量、单价预填写 -->
        <el-dialog
            :close-on-click-modal="false"
            title="加入清单"
            :visible.sync="rowVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            custom-class="add-row-dialog"
            style="margin-left: -170px"
        >
            <div class="form-div">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="汽配编码">
                        <el-input v-model="rowForm.APCode" disabled />
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-input v-model="rowForm.GoodName" disabled />
                    </el-form-item>
                    <el-form-item label="车型">
                        <el-input v-model="rowForm.AutoSerise" disabled />
                    </el-form-item>
                    <el-form-item label="数量">
                        <el-input-number :min="1" :precision="0" controls-position="right" v-model="rowForm._count" />
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input-number :min="0" :precision="2" controls-position="right" v-model="rowForm._price" />
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button class="btn-primary" size="small" @click="rowConfirm">提交</el-button>
                <el-button size="small" @click="rowClose">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="询价历史"
            :visible.sync="inqHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div v-if="inqHistoryVisible">
                <APInquiryHistory
                    ref="APInquiryHistory"
                    :EntpTempGoodsId="hisGoodsId"
                    :Source="1"
                    @closeDialog="
                        () => {
                            inqHistoryVisible = false;
                        }
                    "
                ></APInquiryHistory>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedITitle"
            :close-on-click-modal="false"
            :visible.sync="needInDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needInDataVisible">
                <APNeedInDatas ref="APNeedInDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needInDataVisible = false"></APNeedInDatas>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedOTitle"
            :close-on-click-modal="false"
            :visible.sync="needOutDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needOutDataVisible">
                <APNeedOutDatas ref="APNeedOutDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needOutDataVisible = false"></APNeedOutDatas>
            </div>
        </el-dialog>
        <el-dialog
            title="配件信息"
            :close-on-click-modal="false"
            :visible.sync="APMsgVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="1000px"
        >
            <div v-if="APMsgVisible">
                <APMsg ref="APMsg" :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsId" :edit="false" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!-- 配件搜索条件弹窗 -->
        <el-dialog
            ref="searchItem"
            :close-on-click-modal="false"
            title="配件条件"
            :visible.sync="searchItemVisible"
            width="360px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-muil-dialog"
            custom-class="search-item-dialog"
            style="margin-left: 400px"
            :before-close="digClost"
        >
            <div class="dialog-content" v-if="searchItemVisible">
                <el-form ref="form" label-position="left" label-width="68px">
                    <el-form-item label="联合搜索">
                        <el-input
                            ref="search_0"
                            style="width: 100%"
                            size="small"
                            clearable
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                            @focus="selectAutoHandle('search_0')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="汽配编码">
                        <el-autocomplete
                            ref="search_1"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCode"
                            :fetch-suggestions="searchAPCode"
                            :debounce="500"
                            placeholder="请输入汽配编码"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-autocomplete
                            ref="search_2"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            :fetch-suggestions="searchGoodName"
                            :debounce="500"
                            placeholder="请输入汽配名称"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-autocomplete
                            ref="search_3"
                            size="small"
                            style="width: 100%"
                            :debounce="500"
                            v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            placeholder="请输入车型"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="客户名称">
                        <el-select
                            ref="search_4"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.CusName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="客户名称/电话"
                            :remote-method="searchCustom"
                            v-select-scroll-more="searchCustomLoad"
                        >
                            <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                <div class="name">
                                    {{ item.EntpCusName }}
                                    <span v-if="item.CallNum" class="phone">
                                        {{ ` ( 电话：${item.CallNum} )` }}
                                    </span>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售单号">
                        <el-input size="small" v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode" placeholder="销售单号"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            ref="search_5"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="getGoodsType($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌">
                        <el-select
                            ref="search_6"
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="getGoodsBrand($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产地">
                        <el-autocomplete
                            ref="search_7"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Origin"
                            :fetch-suggestions="searchOrigin"
                            :debounce="500"
                            placeholder="请输入产地信息"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="提交时间">
                        <el-date-picker
                            ref="search_8"
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="handleChange"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APHistory from '@/components/common/APHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
import APInquiryHistory from '@/components/common/APInquiryHistory';
import APNeedInDatas from '@/components/common/APNeedInDatas';
import APNeedOutDatas from '@/components/common/APNeedOutDatas';
import APPurReturnHistory from '@/components/common/APPurReturnHistory';
import APSaleReturnHistory from '@/components/common/APSaleReturnHistory';
import APMsg from '@/components/common/APMsg';
import tableSets from '@/components/common/tableSets.vue';
export default {
    name: '',
    props: [
        'EntpCusId',
        'EntpCusName',
        'canEdit',
        'OnlyOneOption',
        'StorageId',
        'Source', //来源，0表示该组件用于销售单(1采购)编辑页面，来表示是否要判断仓位的类型；不需要的功能不必添加该属性
        'SelectedData', //已经选择了的数据，需要被过滤的数据
        'dragType', // 弹框类型：1 表示从开单页进入
        'dragSign', // 弹框标识
        'isMultiSup', //是否来自多供应商采购
        'warehouseName'
    ],
    components: {
        APPurchaseHistory,
        APHistory,
        goodsAnalysis,
        APInquiryHistory,
        APNeedInDatas,
        APNeedOutDatas,
        APMsg,
        APPurReturnHistory,
        APSaleReturnHistory,
        tableSets
    },
    data() {
        return {
            currentRow: null,
            dateTimes: [],
            searchIndex: 0,
            canSearch: true,
            searchItemVisible: false,
            historyVisible: false,
            historyReVisible: false,
            eyeHistoryVisible: false,
            eyeReHistoryVisible: false,
            goodsAnalysisVisible: false,
            inqHistoryVisible: false,
            needInDataVisible: false,
            needOutDataVisible: false,
            NeedITitle: '',
            NeedOTitle: '',
            SaleDialogTitle: '',
            SaleReDialogTitle: '',
            hisGoodsId: '', //查看销售或采购历史的配件id
            loading: false,
            typeList: [],
            brandList: [],
            dialogType: '-1',
            isSearch: false,
            tableCode: 'SearchUrgentGoods',
            searchData: {
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                Cate: '',
                JointSearch: '',
                CusName: '',
                OrderCode: '',
                WarehouseId: this.StorageId,
                Origin: '',
                CStartDate: '',
                CEndDate: '',
                page: 1,
                limit: 25,
                SearchType: 2
            },
            searchParams: {}, //这个才是真正请求列表接口的条件，当页面等于1的时候重新取searchData的值，searchData目前用来绑定控件数据
            tableData: [],
            tableDataLength: 0,
            selection: [],
            stopFresh: false,
            columnShowSets: {
                APCode: { ColumnName: '', IsShow: false, Width: 0 },
                GoodCode: { ColumnName: '', IsShow: false, Width: 0 },
                GoodName: { ColumnName: '', IsShow: false, Width: 0 },
                AutoSerise: { ColumnName: '', IsShow: false, Width: 0 },
                Cate: { ColumnName: '', IsShow: false, Width: 0 },
                Brand: { ColumnName: '', IsShow: false, Width: 0 },
                Origin: { ColumnName: '', IsShow: false, Width: 0 },
                Unit: { ColumnName: '', IsShow: false, Width: 0 },
                SalesCount: { ColumnName: '', IsShow: false, Width: 0 },
                // CostPrice: { ColumnName: '', IsShow: false, Width: 0 },
                Price: { ColumnName: '', IsShow: false, Width: 0 },
                TotalPrice: { ColumnName: '', IsShow: false, Width: 0 },
                SaleOrderCode: { ColumnName: '', IsShow: false, Width: 0 },
                CusName: { ColumnName: '', IsShow: false, Width: 0 }
            },
            separator: '',
            // isAddWaitIn: true,
            isCanTBSet: false,
            // 新增行内容
            rowVisible: false,
            rowForm: {},
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 335);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            scrollTop: 0,
            scrollLeft: 0,
            APMsgVisible: false,
            isStartSearch: false,
            noInit: true,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            apCodeOptions: [],
            apCodeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            originOptions: [],
            originForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            tableSetsVisible: false
        };
    },
    watch: {
        tableData() {
            this.doLayout();
        },
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    if (this.$refs.search_0) this.$refs.search_0.focus();
                });
            }
        }
    },
    created() {
        this.getConfigByCodes();
        if (this.tableCode) {
            this.getSetsData();
            // this.getSearchCrtSetsData();
            // this.getJointSearchSets();
        }
        this.getJointSearchSets();
    },
    mounted() {
        this.searchData.Source = this.Source;
        // 打开时禁止页面滚动
        document.body.style = 'overflow:hidden';
        this.showSearchItem();
    },
    destroyed() {
        document.body.style = 'overflow:auto';
    },
    filters: {
        AutoSeriseTextSplit(x) {
            if (~x.indexOf(',')) {
                return x.split(',').join('<br/>');
            } else {
                return x;
            }
        }
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        // 单击一行，更新所有弹框内容
        rowClick(row) {
            this.currentRow = row;
            if (this.historyVisible) {
                this.$refs.APPurchaseHistory.updateTableData(row.EntpTempGoodsId);
            }
            if (this.eyeHistoryVisible) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.$refs.APHistory.updateTableData(row.EntpTempGoodsId);
            }
            if (this.historyReVisible) {
                this.$refs.APPurReturnHistory.updateTableData(row.EntpTempGoodsId);
            }
            if (this.eyeReHistoryVisible) {
                this.SaleReDialogTitle = '销售退货数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.$refs.APSaleReturnHistory.updateTableData(row.EntpTempGoodsId);
            }
            if (this.goodsAnalysisVisible) {
                this.$refs.goodsAnalysis.updateTableData(row.EntpTempGoodsId);
            }
            if (this.rowVisible) {
                this.dblChooseAps(row);
            }
        },
        /**
         * 表格滚动
         * 只有在滚动到底部，并且下方还有数据的情况下刷新
         */
        tableLoad() {
            if (!this.stopFresh && !this.loading) {
                //第一页还没有数据就去请求第二页，想太多了吧`(*>﹏<*)′
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.OrderRsId;
        },
        onColumnSelect(val) {
            this.selection = val;
        },
        // 选择配件
        chooseAP(item) {
            this.$emit('closeDialog', item);
        },
        //多选配件
        chooseAPs() {
            let items = this.selection;
            this.$emit('closeDialog', items);
        },
        chooseAllAPs() {
            if (this.tableDataLength == 0) return;
            this.searchData.limit = this.tableDataLength;
            this.searchData.page = 1;
            this.tableData = [];
            this.$emit('chooseAllAPsHandle', {
                searchData: this.searchData
            });
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        rowConfirm() {
            let index = this.tableData.findIndex(e => e.EntpTempGoodsId == this.rowForm.EntpTempGoodsId);
            if (index > -1) {
                this.tableData.splice(index, 1);
                this.searchData.SelectedData.push(this.rowForm.EntpTempGoodsId);
            }

            this.$emit('closeDialog', [this.rowForm], true);
            this.rowVisible = false;
        },
        rowClose() {
            this.rowVisible = false;
            this.rowForm = {};
        },
        // 列表双击打开弹框
        dblChooseAps(e) {
            if ([e][0] && this.dragType * 1 === 1) {
                let _price = 0;
                // 针对不同的开单页，赋予不同的价格
                if (this.dragSign === 'supplierRFQEdit') {
                    // _price = e.Price;
                    _price = e.LatestPurPrice ? e.LatestPurPrice : e.CostPrice;
                } else if (this.dragSign === 'transToSupplierOrder') {
                    // _price = e.CostPrice;
                    _price = e.LatestPurPrice ? e.LatestPurPrice : e.CostPrice;
                } else if (['bjEdit', 'salesOrderEdit'].includes(this.dragSign)) {
                    _price = e.LatestPrice;
                } else {
                    _price = e.Price;
                }
                this.rowVisible = true;
                this.rowForm = {
                    ...[e][0],
                    _count: 1,
                    _price
                };
            } else {
                this.$emit('closeDialog', [e]);
            }
        },

        closeDialog(isEdit) {
            this.tableSetsVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        },
        //采购历史
        showHistories(id) {
            if (id) {
                this.hisGoodsId = id;
                this.historyVisible = true;
            } else {
                if (this.currentRow) {
                    this.noInit = false;
                    this.hisGoodsId = this.currentRow.EntpTempGoodsId;
                    this.historyVisible = true;
                } else this.$util.warningMsg('未选中数据');
            }
        },
        showReHistories(id) {
            if (id) {
                this.hisGoodsId = id;
                this.historyReVisible = true;
            } else {
                if (this.currentRow) {
                    this.noInit = false;
                    this.hisGoodsId = this.currentRow.EntpTempGoodsId;
                    this.historyReVisible = true;
                } else this.$util.warningMsg('未选中数据');
            }
        },
        // 历史销售
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.hisGoodsId = row.EntpTempGoodsId;
                this.eyeHistoryVisible = true;
            } else {
                if (this.currentRow) {
                    this.noInit = false;
                    this.SaleDialogTitle = '销售数据：' + this.currentRow.APCode + ' ' + this.currentRow.GoodName + ' ' + this.currentRow.AutoSerise;
                    this.hisGoodsId = this.currentRow.EntpTempGoodsId;
                    this.eyeHistoryVisible = true;
                } else this.$util.warningMsg('未选中数据');
            }
        },
        showSaleReStat(row) {
            if (row) {
                this.SaleReDialogTitle = '销售退货数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.hisGoodsId = row.EntpTempGoodsId;
                this.eyeReHistoryVisible = true;
            } else {
                if (this.currentRow) {
                    this.noInit = false;
                    this.SaleReDialogTitle = '销售退货数据：' + this.currentRow.APCode + ' ' + this.currentRow.GoodName + ' ' + this.currentRow.AutoSerise;
                    this.hisGoodsId = this.currentRow.EntpTempGoodsId;
                    this.eyeReHistoryVisible = true;
                } else this.$util.warningMsg('未选中数据');
            }
        },
        analysis(row) {
            if (row) {
                this.hisGoodsId = row.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            } else {
                if (this.currentRow) {
                    this.noInit = false;
                    this.hisGoodsId = this.currentRow.EntpTempGoodsId;
                    this.goodsAnalysisVisible = true;
                } else this.$util.warningMsg('未选中数据');
            }
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                })
                .catch(() => {});
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                })
                .catch(() => {});
        },
        resetSearch() {
            this.searchData = {
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                Cate: '',
                JointSearch: '',
                CusName: '',
                OrderCode: '',
                WarehouseId: this.StorageId,
                Origin: '',
                CStartDate: '',
                CEndDate: '',
                page: 1,
                limit: 25,
                SearchType: 2
            };
            this.dateTimes = [];
            this.isSearch = false;
        },
        getTableData() {
            return new Promise(resolve => {
                if (this.SelectedData && this.SelectedData.length > 0) {
                    this.searchData.SelectedData = this.SelectedData;
                }
                if (this.searchData.page == 1) {
                    this.searchParams = { ...this.searchData };
                } else {
                    this.searchParams.page = this.searchData.page;
                }
                this.loading = true;
                this.stopFresh = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpPurchaseOrder/SearchSaleUrgentGoods',
                        data: this.searchParams,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (this.searchData.page == 1) this.tableDataLength = res.count;
                        if (!data) {
                            if (this.searchData.page == 1) this.tableData = [];
                            this.loading = false;
                            return;
                        }
                        let goodsList = data;
                        let list = [...this.tableData, ...goodsList];
                        // const maps = new Map();
                        // list = list.filter(m => !maps.has(m.EntpTempGoodsId) && maps.set(m.EntpTempGoodsId, 1));
                        //因为接口的原因，返回前后两页数据有重复，所以在这里做去重
                        this.tableData = list;

                        this.stopFresh = goodsList.length < this.searchData.limit;

                        resolve(this.tableData);
                        this.loading = false;

                        // this.getOtherData(goodsList);
                    })
                    .catch(e => {
                        this.loading = false;
                    });
            });
        },
        async getOtherData(data) {
            let that = this;
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    that.loopGetData(data[i].GoodsId);
                    await that.$util.sleep(150);
                }
            }
        },
        loopGetData(id) {
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/GetAfterSearchGoodsForMulPur',
                    data: {
                        GoodsId: id,
                        SId: that.StorageId,
                        Source: that.Source,
                        IsMultiSup: true
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.tableData.forEach(item => {
                        if (item.EntpTempGoodsId == data.GoodsId) {
                            // item.OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            // item.POrderWaitInQuantity = data.POrderWaitInQuantity;
                            item.Supplier = data.Supplier;
                            return;
                        }
                    });
                })
                .catch(() => {});
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order ? event.order : '';
            if (this.searchData.SortType == '') this.searchData.SortProp = '';
            this.searchData.page = 1;
            this.tableData = [];
            this.scrollTop = 0;
            this.scrollLeft = 0;
            this.getTableData();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.tableData = [];
            this.$refs.dialogTable.clearSelection();
            this.isSearch = true;
            // 防止多次点击
            if (!this.loading) {
                this.scrollTop = 0;
                this.scrollLeft = 0;
                this.getTableData();
            }
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },

        // 重新渲染table组件，用于处理刷新页面后配置 fixed="right" 的列出现样式错误的问题
        doLayout() {
            this.$nextTick(() => {
                this.$refs.dialogTable.doLayout();
            });
        },
        getConfigByCodes() {
            let codes = ['ygsfkzdylb'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            // case 'lybsdr': //获取留余的计算方式
                            //     this.isAddWaitIn = !result;
                            //     break;
                            case 'ygsfkzdylb': //是否可自定义列表
                                this.isCanTBSet = result;
                                break;
                        }
                    }
                }
            });
        },
        showIntentDatas(id) {
            if (id) {
                if (this.inqHistoryVisible) {
                    this.$refs.APInquiryHistory.updateTableData(id);
                } else {
                    this.hisGoodsId = id;
                    this.inqHistoryVisible = true;
                }
            }
        },
        showNeedInData(item) {
            if (item.EntpTempGoodsId && !this.needInDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedITitle = '【配件待入数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needInDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needInDataVisible) {
                this.$refs.APNeedInDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        showNeedOutData(item) {
            if (item.EntpTempGoodsId && !this.needOutDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedOTitle = '【配件待出数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needOutDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needOutDataVisible) {
                this.$refs.APNeedOutDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        handleChange(val) {
            if (val) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id && !this.APMsgVisible) {
                this.EntpTempGoodsId = id;
                this.APMsgVisible = true;
            } else {
                this.$refs.APMsg.updateTableData(id);
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
        },
        showSearchItem() {
            if (!this.searchItemVisible) {
                this.searchItemVisible = true;
                this.$emit('setItemVisible', true);
            }
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            clearTimeout(this.timer);
            this.$nextTick(() => {
                this.timer = setTimeout(() => {
                    if (this.$refs[ref]) this.$refs[ref].select();
                }, 100);
            });
        },
        searchAPCode(key, cb) {
            if (![undefined].includes(key)) {
                this.apCodeForm.Page = 1;
                this.apCodeForm.stopLoad = false;
                this.apCodeForm.key = key;
                this.apCodeOptions = [];
            }
            let callback = cb;
            if (this.apCodeForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.apCodeForm.key, 0, this.apCodeForm.Page, this.apCodeForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.apCodeForm.stopLoad = data.length < this.apCodeForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.apCodeOptions = [...this.apCodeOptions, ...arr];
                if (callback) {
                    callback(this.apCodeOptions);
                }
            });
        },
        searchGoodName(key, cb) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            let callback = cb;
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = [...this.goodNameOptions, ...arr];
                if (callback) {
                    callback(this.goodNameOptions);
                }
            });
        },
        searchAutoSerise(key, cb) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            let callback = cb;
            if (this.autoSeriseForm.stopLoad) return;
            this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...arr];
                if (callback) {
                    callback(this.autoSeriseOptions);
                }
            });
        },
        searchOrigin(key, cb) {
            if (![undefined].includes(key)) {
                this.originForm.Page = 1;
                this.originForm.stopLoad = false;
                this.originForm.key = key;
                this.originOptions = [];
            }
            let callback = cb;
            if (this.originForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.originForm.key, 3, this.originForm.Page, this.originForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.originForm.stopLoad = data.length < this.originForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.originOptions = [...this.originOptions, ...arr];
                if (callback) {
                    callback(this.originOptions);
                }
            });
        },
        stopSearch() {
            this.canSearch = false;
        },
        digClost() {
            this.searchItemVisible = false;
            this.$emit('setItemVisible', false);
        },
        keyUpFunc() {
            let that = this;
            if (that.searchIndex != 0) {
                if (
                    that.$refs.search_5 &&
                    !that.$refs.search_5.visible &&
                    that.$refs.search_6 &&
                    !that.$refs.search_6.visible &&
                    that.$refs.search_1 &&
                    !that.$refs.search_1.suggestionVisible &&
                    that.$refs.search_10 &&
                    !that.$refs.search_10.suggestionVisible &&
                    that.$refs.search_2 &&
                    !that.$refs.search_2.suggestionVisible &&
                    that.$refs.search_3 &&
                    !that.$refs.search_3.suggestionVisible
                ) {
                    if (that.searchIndex == 5 || that.searchIndex == 6) {
                        if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                    }
                    that.searchIndex -= 1;
                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                }
            }
            return;
        },
        keyDownFunc() {
            let that = this;
            if (that.searchIndex < 11) {
                if (
                    that.$refs.search_5 &&
                    !that.$refs.search_5.visible &&
                    that.$refs.search_6 &&
                    !that.$refs.search_6.visible &&
                    that.$refs.search_1 &&
                    !that.$refs.search_1.suggestionVisible &&
                    that.$refs.search_10 &&
                    !that.$refs.search_10.suggestionVisible &&
                    that.$refs.search_2 &&
                    !that.$refs.search_2.suggestionVisible &&
                    that.$refs.search_3 &&
                    !that.$refs.search_3.suggestionVisible
                ) {
                    if (that.searchIndex == 5 || that.searchIndex == 6) {
                        if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                    }
                    that.searchIndex += 1;
                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                }
            }
            return;
        },
        keyESCFunc() {
            let that = this;
            that.canSearch = true;
            if (
                (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) ||
                (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) ||
                (that.$refs.search_3 && that.$refs.search_3.suggestionVisible) ||
                (that.$refs.search_10 && that.$refs.search_10.suggestionVisible)
            ) {
                if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                if (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) that.$refs.search_1.suggestions = [];
                if (that.$refs.search_10 && that.$refs.search_10.suggestionVisible) that.$refs.search_10.suggestions = [];
                if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                return;
            } else {
                this.$emit('closeSearchDialog');
            }
        },
        //当拖动表头改变了列的宽度的时候会触发该事件
        headerDragend() {
            this.doLayout();
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'APCode':
                            this.columnShowSets.APCode.IsShow = item.IsShow;
                            this.columnShowSets.APCode.Width = item.Width;
                            this.columnShowSets.APCode.ColumnName = item.ColumnName;
                            break;
                        case 'GoodName':
                            this.columnShowSets.GoodName.IsShow = item.IsShow;
                            this.columnShowSets.GoodName.Width = item.Width;
                            this.columnShowSets.GoodName.ColumnName = item.ColumnName;
                            break;
                        case 'AutoSerise':
                            this.columnShowSets.AutoSerise.IsShow = item.IsShow;
                            this.columnShowSets.AutoSerise.Width = item.Width;
                            this.columnShowSets.AutoSerise.ColumnName = item.ColumnName;
                            break;
                        case 'Cate':
                            this.columnShowSets.Cate.IsShow = item.IsShow;
                            this.columnShowSets.Cate.Width = item.Width;
                            this.columnShowSets.Cate.ColumnName = item.ColumnName;
                            break;
                        case 'Brand':
                            this.columnShowSets.Brand.IsShow = item.IsShow;
                            this.columnShowSets.Brand.Width = item.Width;
                            this.columnShowSets.Brand.ColumnName = item.ColumnName;
                            break;
                        case 'Origin':
                            this.columnShowSets.Origin.IsShow = item.IsShow;
                            this.columnShowSets.Origin.Width = item.Width;
                            this.columnShowSets.Origin.ColumnName = item.ColumnName;
                            break;
                        // case 'CostPrice':
                        //     this.columnShowSets.CostPrice.IsShow = item.IsShow;
                        //     this.columnShowSets.CostPrice.Width = item.Width;
                        //     this.columnShowSets.CostPrice.ColumnName = item.ColumnName;
                        //     break;
                        case 'Price':
                            this.columnShowSets.Price.IsShow = item.IsShow;
                            this.columnShowSets.Price.Width = item.Width;
                            this.columnShowSets.Price.ColumnName = item.ColumnName;
                            break;
                        case 'Unit':
                            this.columnShowSets.Unit.IsShow = item.IsShow;
                            this.columnShowSets.Unit.Width = item.Width;
                            this.columnShowSets.Unit.ColumnName = item.ColumnName;
                            break;
                        case 'SalesCount':
                            this.columnShowSets.SalesCount.IsShow = item.IsShow;
                            this.columnShowSets.SalesCount.Width = item.Width;
                            this.columnShowSets.SalesCount.ColumnName = item.ColumnName;
                            break;
                        case 'TotalPrice':
                            this.columnShowSets.TotalPrice.IsShow = item.IsShow;
                            this.columnShowSets.TotalPrice.Width = item.Width;
                            this.columnShowSets.TotalPrice.ColumnName = item.ColumnName;
                            break;
                        case 'SaleOrderCode':
                            this.columnShowSets.SaleOrderCode.IsShow = item.IsShow;
                            this.columnShowSets.SaleOrderCode.Width = item.Width;
                            this.columnShowSets.SaleOrderCode.ColumnName = item.ColumnName;
                            break;
                        case 'CusName':
                            this.columnShowSets.CusName.IsShow = item.IsShow;
                            this.columnShowSets.CusName.Width = item.Width;
                            this.columnShowSets.CusName.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    margin-top: 5px;
}
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    // height: 615px;
    overflow-y: auto;
}
.search-ctn-left {
    .search-row {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
}
.ops-ctn {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 2px;
    .scolor {
        color: #db3737;
    }
    .pcolor {
        color: #0f9960;
    }
}
.tooltip-div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
}
/deep/.dialog-search-table-ctn {
    .elx-table {
        .elx-table--body-wrapper {
            padding-bottom: 0px !important;
            .c--tooltip {
                line-height: 32px;
                padding-left: 5px;
            }
        }
    }
    .sp-i {
        margin-left: -6px;
        margin-right: 2px;
    }
    .el-icon-info {
        color: #87a7d6;
        font-size: 18px;
        vertical-align: top;
        margin-top: 1px;
        cursor: pointer;
    }

    .el-icon-picture {
        color: rgb(240, 155, 27);
        font-size: 18px;
        vertical-align: top;
        margin-top: 1px;
        cursor: pointer;
    }
}
</style>
<style lang="less">
.dialog-s-content {
    .dialog-cascader-panel,
    .el-cascader-menu__wrap {
        height: 100%;
    }
    .el-cascader-menu__wrap {
        width: 186px;
    }
    .el-cascader-node__label {
        padding-right: 0;
    }
}
.search-table-i {
    .el-table {
        .el-table__body {
            .current-row {
                > td {
                    background-color: #bbddff;
                }
            }
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }
                td {
                    padding: 2px 0;
                }
            }
        }
        th {
            padding: 4px 0;
        }
    }
}
.searchAp-ctn {
    .el-select {
        .el-select__tags {
            flex-wrap: nowrap;
            overflow: hidden;
        }
    }
    .el-table {
        .el-table__row:hover > td {
            background-color: #dcdee1;
        }
    }
}
#change-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        width: 1000px;
        // height: 500px;
        box-shadow: 0 0 9px 3px #999;
    }
    .add-row-dialog {
        width: 340px;
        height: auto;
        .form-div {
            margin-top: 20px;
        }
        .dialog-footer {
            text-align: right;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
#search-muil-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
//重新设置层级，不然鼠标移到设置内容过长的单元格时，无法显示内容
.elx-table--tooltip-wrapper {
    z-index: 9999 !important;
}
</style>
